import { alpha, createTheme } from '@mui/material/styles';

/** Same tokens as the Whatzneu Finance customer app. Used only inside customer screens. */
export const brand = {
  navy: '#101828',
  charcoal: '#1D2939',
  ivory: '#F9F8F5',
  gold: '#C6A76A',
  goldSoft: '#F3EBDD',
  slate: '#667085',
  border: '#E4E7EC',
  white: '#FFFFFF',
  mist: '#D0D5DD',
  danger: '#8C3A3A',
  dangerSoft: '#F8EEEE',
  positive: '#3E5C4B',
  positiveSoft: '#E8F0EB',
  warning: '#8A6232',
  warningSoft: '#F8F1E6',
} as const;

export const portalTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: brand.navy, contrastText: brand.ivory },
    secondary: { main: brand.gold, contrastText: brand.navy },
    background: { default: brand.ivory, paper: brand.white },
    text: { primary: brand.navy, secondary: brand.slate },
    success: { main: brand.positive },
    error: { main: brand.danger },
    warning: { main: brand.warning },
    divider: brand.border,
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
    overline: { letterSpacing: '0.18em', fontWeight: 700 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: { body: { backgroundColor: brand.ivory } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: `1px solid ${brand.border}` } },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12, paddingInline: 18 },
        containedSecondary: { color: brand.navy },
      },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600 } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 20 } },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { color: brand.slate, fontWeight: 700, backgroundColor: alpha(brand.goldSoft, 0.5) },
      },
    },
  },
});
